import { WebStorageStateStore, UserManager } from "oidc-client-ts";

const authority = import.meta.env.VITE_COGNITO_AUTHORITY;
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN?.replace(/\/$/, "");

if (!authority || !clientId || !cognitoDomain) {
  throw new Error(
    "VITE_COGNITO_AUTHORITY, VITE_COGNITO_DOMAIN, and VITE_COGNITO_CLIENT_ID are required",
  );
}

export const userManager = new UserManager({
  authority,
  client_id: clientId,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid email profile",
  automaticSilentRenew: true,
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  metadata: {
    issuer: authority,
    authorization_endpoint: `${cognitoDomain}/oauth2/authorize`,
    token_endpoint: `${cognitoDomain}/oauth2/token`,
    userinfo_endpoint: `${cognitoDomain}/oauth2/userInfo`,
    jwks_uri: `${authority}/.well-known/jwks.json`,
    end_session_endpoint: `${cognitoDomain}/logout`,
  },
});

export async function currentIdToken(): Promise<string | null> {
  const user = await userManager.getUser();
  return user && !user.expired ? (user.id_token ?? null) : null;
}

export async function login(): Promise<void> {
  await userManager.signinRedirect({
    extraQueryParams: { identity_provider: "Google" },
  });
}

export async function logout(): Promise<void> {
  await userManager.signoutRedirect();
}
